import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineIdentification, HiOutlineBriefcase, HiOutlineUser, HiOutlinePaperAirplane, HiOutlineSquares2X2 } from "react-icons/hi2";
import { ROUTES, CONTACT_EMAIL } from "../../../../helpers/constants";
import { featureToggles } from "../../../../utils/featureToggles";
import ClientPlansModal from "./client-plans-modal";

const initials = (name = "") =>
  name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((word) => word[0]).join("").toUpperCase() || "?";

// Cabecera de la ficha del cliente: datos de la empresa, pruebas enviadas y
// disponibles (con sus botones de siempre) y el contacto del responsable.
// `actions`: botones que agrega la pantalla (p. ej. "Editar" para superadmin).
const FolderContentComponent = ({ client, actions, isSuperAdmin }) => {
  const navigate = useNavigate();
  const [isPlansOpen, setIsPlansOpen] = useState(false);
  const togglePlans = () => setIsPlansOpen((prev) => !prev);
  const canPurchase = featureToggles.isEnabled('enablePurchaseSection');
  const showPlans = featureToggles.isEnabled('enableClientsPlans');

  return (
    <div className="gm-client-detail-head">
      <header className="gm-ch">
        <div className="gm-ch-main">
          <div className="gm-co-logo" aria-hidden="true">{initials(client?.name)}</div>
          <div className="gm-ch-text">
            <div className="gm-eyebrow">{isSuperAdmin ? "Cliente" : "Mi empresa"}</div>
            <h1>{client?.name}</h1>
            <div className="gm-ch-meta">
              {client?.rut && <span><HiOutlineIdentification size={15} />{client.rut}</span>}
              <span><HiOutlineBriefcase size={15} />{client?.sector || "Rubro no informado"}</span>
            </div>
          </div>
        </div>
        {actions && <div className="gm-ch-actions">{actions}</div>}
      </header>

      <div className="gm-client-overview">
        <div className="gm-kpi">
          <div className="gm-kpi-label"><HiOutlinePaperAirplane size={16} />Pruebas enviadas</div>
          <div className="gm-kpi-value">{client?.testsDone || 0}</div>
        </div>
        <div className="gm-kpi">
          <div className="gm-kpi-label"><HiOutlineSquares2X2 size={16} />Pruebas disponibles</div>
          <div className="gm-kpi-value">{client?.testsAvailable || 0}</div>
          <div className="gm-kpi-actions">
            {canPurchase &&
              <button
                type="button"
                className="gm-primary-button"
                onClick={() => navigate(ROUTES.PURCHASE.route, { state: { client } })}
              >
                Necesito más tests
              </button>
            }
            {showPlans &&
              <button type="button" className="gm-outline-button" onClick={togglePlans}>
                Mis planes
              </button>
            }
          </div>
          {!canPurchase &&
            <p className="gm-kpi-foot">¿Necesitas más tests? Escríbenos a <b>{CONTACT_EMAIL}</b></p>
          }
        </div>
        <div className="gm-kpi gm-contact-card">
          <div className="gm-kpi-label"><HiOutlineUser size={16} />Responsable</div>
          <dl className="gm-contact-list">
            <div><dt>Nombre</dt><dd>{client?.responsibleName || "—"}</dd></div>
            <div><dt>Cargo</dt><dd>{client?.responsiblePosition || "—"}</dd></div>
            <div><dt>Correo</dt><dd>{client?.responsibleEmail || "—"}</dd></div>
            <div><dt>Teléfono</dt><dd>{client?.responsiblePhoneNumber || "—"}</dd></div>
          </dl>
        </div>
      </div>

      {showPlans &&
        <ClientPlansModal
          open={isPlansOpen}
          toggle={togglePlans}
          clientId={client?.id}
        />
      }
    </div>
  );
};

export default FolderContentComponent;
